import { render, staticRenderFns } from "./NotAccess.vue?vue&type=template&id=2ff78d99&scoped=true&"
import script from "./NotAccess.vue?vue&type=script&lang=js&"
export * from "./NotAccess.vue?vue&type=script&lang=js&"
import style0 from "./NotAccess.vue?vue&type=style&index=0&id=2ff78d99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff78d99",
  null
  
)

export default component.exports